import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { AppSharedModule } from '../../../../app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from '../../../../services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-widget-expansion-panel',
  imports: [AppSharedModule],
  templateUrl: './widget-expansion-panel.component.html',
  styleUrl: './widget-expansion-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetExpansionPanelComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() title: string;

  @Output() onClose = new EventEmitter<void>();

  close(): void {
    this.onClose.emit();
  }
}
